import React from 'react';
import { marginOf, MARGIN_STYLE, marginTitle } from '../services/margin';

// Admin: coloured margin badge (HT) for a product
const MarginBadge = ({ product, vatRate = 20, testId, compact = false }) => {
  const m = marginOf(product, vatRate);
  return (
    <span data-testid={testId} title={marginTitle(m, vatRate)} className={`inline-flex flex-col items-start leading-tight px-2 py-1 rounded-md text-xs font-semibold ${MARGIN_STYLE[m.level]}`}>
      {m.level === 'none' ? (
        <span>— <span className="font-normal">pas de PA</span></span>
      ) : (
        <>
          <span>{m.pct.toFixed(0)} %</span>
          {!compact && <span className="font-normal">{m.margin >= 0 ? '+' : ''}{m.margin.toFixed(2)} € HT</span>}
        </>
      )}
    </span>
  );
};

export default MarginBadge;
